import Image from "next/image";

import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IClaimRewardMetadata } from "shared/components/organisms/AppNotification/@types/claimRewardTypes";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { ClaimRewardNotificationContainer } from "./styles";

interface IClaimRewardNotificationProps {
  notification: INotification<IClaimRewardMetadata>;
}

export const ClaimRewardNotification = ({
  notification,
}: IClaimRewardNotificationProps) => {
  return (
    <ClaimRewardNotificationContainer>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          <Image
            alt={notification?.metadata?.item?.title}
            src={notification?.metadata?.item?.main_image}
            width={32}
            height={32}
          />
        </Notification.IllustrationContainer>

        <Notification.Title.Container>
          <Notification.Title.Highlight>
            Atualização
          </Notification.Title.Highlight>

          <Notification.Title.Text>
            sobre uma recompensa reinvidicada
          </Notification.Title.Text>
        </Notification.Title.Container>

        <Notification.Content.Container>
          <Notification.Content.Text>
            {notification?.metadata?.comment}
          </Notification.Content.Text>
        </Notification.Content.Container>

        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>

          <Notification.Footer.Dot />

          <Notification.Footer.Image
            label={notification?.metadata?.item?.title}
            src={null}
            backgroundColor={null}
          />
        </Notification.Footer.Container>
      </Notification.Container>
    </ClaimRewardNotificationContainer>
  );
};
